import { render, staticRenderFns } from "./PostHire.vue?vue&type=template&id=2c1010e9&"
import script from "./PostHire.vue?vue&type=script&lang=js&"
export * from "./PostHire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports